import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark'
import Button from '@hotmart/space-lib/dist/components/button'
import Icon from '@hotmart/space-lib/dist/components/icon'
import clsx from 'clsx'
import { useUser } from 'src/hook/useUser'
import { UserAvatar } from 'src/components'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import { RiCollapseDiagonal2Line, RiExpandDiagonalS2Line } from '@remixicon/react'
import { Divider, CustomButton } from './postModalHeader.styles'
import { PostModalHeaderProps } from './postModalHeader.types'

const PostModalHeader = ({
  className,
  isFullScreen = false,
  handleModalFullScreen,
  handleOnClose
}: PostModalHeaderProps) => {
  const { community } = useCommunityDetails()

  const {
    user: { socialName: userName },
    avatar
  } = useUser()

  const icon = isFullScreen ? (
    <RiCollapseDiagonal2Line
      className="_cursor-pointer"
      size={24}
      data-test="full-screen-close-icon"
    />
  ) : (
    <RiExpandDiagonalS2Line className="_cursor-pointer" size={24} />
  )

  return (
    <div className={clsx('_d-flex _justify-content-start _align-items-center', className)}>
      <div className="_d-flex _justify-content-center _align-items-center">
        <CustomButton
          aria-label="full-screen"
          onClick={handleModalFullScreen}
          className="_bg-transparent _p-0 _border-0 _outline-0"
          name="full-screen"
        >
          {icon}
        </CustomButton>

        <Divider className="_mx-4" />

        <div className="_d-flex _justify-content-start _align-items-center">
          <UserAvatar src={avatar} alt={userName} className="_mr-4" small />

          <div className="_d-flex _flex-column _justify-content-start _align-items-start">
            <h3 className="_text-gray-900 _font-weight-bold _mb-0 _font-14">{userName}</h3>

            <p className={clsx('_text-1 _text-gray-400 _mb-0 _text-gray-600')}>{community.name}</p>
          </div>
        </div>
      </div>

      <Button
        variation="tertiary"
        className="_p-0 _d-flex _border-0 _bg-transparent _text-gray-900 _ml-auto"
        onClick={handleOnClose}
      >
        <span className="_sr-only">close</span>
        <Icon icon={faXmark} className="_w-5 _h-5" />
      </Button>
    </div>
  )
}

export default PostModalHeader
